import _ from "ES/lib/lodash";
import React from "ES/lib/react";
import StandardLayout from "../layout/StandardLayout";


require("./index.less");


export default React.createFactory(React.createClass({
    iframe: function (sid, Displaylists) {

        if (_.isEmpty(sid)) return null;

        let crm_sso_link = _.find(_.get(Displaylists, "perspeaker"), function (spkr) {
            return (spkr.sid == sid);
        });
        crm_sso_link = _.get(_.first(_.get(crm_sso_link, "crm_sso", [])), "sso_url");

        if (_.isEmpty(crm_sso_link)) return null;

        return {
            __html: "<iframe src=\"" + crm_sso_link + "\" width=\"100%\" height=\"100%\" data-sid=\"" + sid + "\"></iframe>"
        };
    },

    render: function () {
        let {Displaylists, url_args} = this.props;
        let sid = _.last(url_args);

        return StandardLayout({Displaylists},
            <div style={{height: "100%", width: "100%"}}>
                <div style={{height: "3em"}}>
                    <a style={{paddingLeft: "1em", paddingTop:"1em", display:"block"}} href="#/events">« back to events</a>
                </div>
                <div dangerouslySetInnerHTML={this.iframe(sid, Displaylists)} style={{height: "100%", width: "100%", border: "none"}}/>
            </div>
        );
    }
}));



// WEBPACK FOOTER //
// ./src/components/crm/index.js